/* eslint-disable */
import axios from "axios";
const url = require("../../client_config/config").url;
import { saveAs } from "file-saver";
import { showAlert } from "../../../utils/AlertHelper";
import DateTimeUtil from "../../../utils/date-time.util";


const itemName = ["Incentives", "Incentive"];
const routes = "incentives";

const state = {
  items: [],
  item: null,
  isLoading: false,
  uploadFileItems: [],
};

const getters = {
  getAllItems: (state) => state.items,
  isLoading: (state) => state.isLoading,
};

const actions = {
  async getItems({ commit }, userId) {
    commit("SET_LOADING", true);
    try {
        let history = await axios.get(`${url}/${routes}/getStaffIncentive/${userId}`).then(res => {
            const staffIncentives = res.data;
            
            staffIncentives.map(staffIncentive => {
                staffIncentive.Date = DateTimeUtil.toLocalDate(staffIncentive.Date)
            })
            
            return staffIncentives
        })

        commit("SET_ITEMS", history);
    } catch (error) {
      console.error(`Error fetching ${itemName[0]}:`, error);
      showAlert("error", `fetching ${itemName[0]}`);
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async getItem({ commit }, id) {
    commit("SET_LOADING", true);
    try {
        const response = await axios.get(`${url}/${routes}/${id}`).then(res => {
            const staffIncentive = res.data;

            staffIncentive.Date = DateTimeUtil.toLocalDate(staffIncentive.Date)
            
            return staffIncentive
        });

        commit("SET_ITEM", response);
    } catch (error) {
        console.error(`Error fetching ${itemName[1]}:`, error);
        showAlert("error", `fetching ${itemName[1]}`);
    } finally {
        commit("SET_LOADING", false);
    }
  },

  async addItem({}, data) {
    try {
      const response = await axios.post(`${url}/${routes}`, data);
      showAlert("added", itemName[1]);
      return response;
    } catch (error) {
      console.error(`Error adding ${itemName[1]}:`, error);
      showAlert("error", `adding ${itemName[1]}`);
      return error.response;
    }
  },

  async updateItem({}, { id, data }) {
    try {
      const response = await axios.put(`${url}/${routes}/${id}`, data);
      showAlert("updated", itemName[1]);
      return response;
    } catch (error) {
      console.error(`Error updating ${itemName[1]}:`, error);
      showAlert("error", `updating ${itemName[1]}`);
      return error.response;
    }
  },
  async uploadItem({ commit }, { file, id, userId }) {
    const formData = new FormData();
    formData.append("Health Care", file);

    try {
      await axios.post(
        `${url}/${routes}/fileuploader/${id}/${userId}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      commit("CLEAR_UPLOAD_FILES");
      showAlert("uploaded", "File");
    } catch (error) {
      console.error("Error uploading file:", error);
      console.log(error.response)
      showAlert("error", "Uploading file");
    }
  },

  async deleteItem({ commit, dispatch }, { id, userId }) {
    try {
      const response = await axios.delete(`${url}/${routes}/${id}`);
      if (response.status === 200) {
        dispatch("getItems", userId);
        showAlert("deleted", itemName[1]);
      }
    } catch (error) {
      console.error(`Error deleting ${itemName[1]}:`, error);
      showAlert("error", `deleting ${itemName[1]}`);
    }
  },

  async downloadItem({ commit }, item) {
    if (!item.documents || item.documents.length === 0) {
      showAlert("error", "No document found");
      return;
    }

    for (const doc of item.documents) {
      const docURL = doc.AWSLink;
      const fileName = doc.Name;

      if (!docURL || !fileName) {
        console.error("Invalid document URL or file name:", docURL, fileName);
        continue;
      }

      try {
        const response = await fetch(docURL);

        if (!response.ok) {
          showAlert("error", "Failed to fetch file");
          return;
        }

        const blob = await response.blob();
        saveAs(blob, fileName);
        showAlert("downloaded", "File");
      } catch (error) {
        console.error("Error downloading file:", error);
        showAlert("error", "Downloading file");
      }
    }
  },
};

const mutations = {
  SET_ITEMS(state, data) {
    state.items = data;
  },
  SET_ITEM(state, data) {
    state.item = data;
  },
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  ADD_UPLOAD_FILE(state, file) {
    state.uploadFileItems.push(file);
  },
  CLEAR_UPLOAD_FILES(state) {
    state.uploadFileItems = [];
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
